var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-file-list"},[_c('div',{staticClass:"post-file-list__rows my-2 mx-n4"},_vm._l((_vm.files),function(item){return _c('post-file-item',{key:item.id,staticClass:"post-file-list__row px-4",class:{ __underline: _vm.underline },attrs:{"post-file":item},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var file = ref.file;
return [_vm._t("itemPrepend",null,{"file":file})]}},{key:"append",fn:function(ref){
var file = ref.file;
return [_vm._t("itemAppend",null,{"file":file})]}},{key:"header",fn:function(ref){
var file = ref.file;
var fileName = ref.fileName;
return [_vm._t("itemFileHeader",null,{"file":file,"fileName":fileName})]}}],null,true)})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }